import React, { useEffect, useState } from 'react'
import PivotTableUI from 'react-pivottable/PivotTableUI';
import GenericInput from '../../../genericComponents/input/GenericInputComponent'
import 'react-pivottable/pivottable.css';
import { getPermissionKey } from '../../../helper/permissions';
import GenericSpinnerLoader from '../../../loaders/GenericSpinnerLoader';
import Icons from '../../../assets/icons';
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { parseJwt } from '../../../helper/genericFunction';
import LanguageTranslator from '../../../locals/LanguageTranslator';
import GenericCustomButton from '../../../genericComponents/GenericCustomButton';
import TableRenderers from 'react-pivottable/TableRenderers';
import { SquareDashedMousePointer } from 'lucide-react';

const PivotTable = () => {

    const [tableData, setTableData] = useState([]);

    const [pivotData, setPivotData] = useState({});

    const [filtersData, setFiltersData] = useState({});

    const [error, setError] = useState({});

    const [loading, setLoading] = useState({});

    const getPivotTableProductData = useSelector(state => state?.digicatStore?.getPivotTableProductData);

    const dispatch = useDispatch();

    console.log("Pivot Data States", {
        pivotData: pivotData,

        tableData: tableData
    })

    useEffect(() => {
        getPivotData()
    }, [filtersData])

    useEffect(() => {
        if(getPivotTableProductData?.isSuccess){
            let updatedLoading = {...loading};
            delete updatedLoading?.["main"];
            setLoading(updatedLoading);
            setTableData(getPivotTableProductData?.data || [])
        }

        if(getPivotTableProductData?.isError){
            let updatedLoading = {...loading};
            delete updatedLoading?.["main"];
            setLoading(updatedLoading);

            let updatedError = {...error};
            updatedError["main"] = getPivotTableProductData?.error?.errorMessage || "Something Went Wrong!"
            setError(updatedError)
        }
    },[getPivotTableProductData])

    // Function : To get the pivot data
    const getPivotData = () => {
        if (filtersData?.["hl3name"]?.["hl3code"] && filtersData?.["season"]?.["season"]) {
            let updatedLoading = { ...loading };
            updatedLoading["main"] = true;
            setLoading(updatedLoading)
            
            let updatedError = {...error};
            delete updatedError["main"] ;
            setError(updatedError)
            
            setPivotData([]);
            setTableData([]);

            dispatchHandler(dispatch, "getPivotTableProductRequest", {
               filter : {
                "hl3Code": filtersData?.["hl3name"]?.["hl3code"],
                "season": filtersData?.["season"]?.["season"]
               }
            },  getPermissionKey("common", "commonfunctionality", "view"))
        }
    }

    const getInputProps = (key) => {

        const getHeaderKeys = () => {
            if (key == "season") {
                return {
                    "season": {value : "Season"},
                }
            }

            if (key == "hl3name") {
                return {
                    "hl3code": { value: "Code" },
                    "hl3name": { value: "Name" },
                }
            }
        }

        const getItemKeys = () => {
            if (key == "season") {
                return {
                    "season": ["season"],
                }
            }
            if (key == "hl3name") {
                return {
                    "hl3code": ["hl3code"],
                    "hl3name": ["hl3name"],
                }
            }
        }

        switch (key) {
            case "season":
            case "hl3name": {
                return {
                    viewDataType: "table-view",
                    headerKeys: getHeaderKeys(),
                    itemKeys: getItemKeys(),
                    search: {
                        placeholder: "Type To Search...",
                    },
                    api: {
                        reduxState: "generalStore",
                        apiName: "getSearchFilters",
                        apiPayload: (params) => {
                            return {
                                "entity": "vendor.product_library",
                                "key": key  ,
                                "code": key == "hl3name" ? "hl3code" : "",
                                "search": params?.currentSearch || "",
                                "searchBy": params.searchFilter || "CONTAINS",
                                "pageNo": params?.currentPage || 1,
                                "other_data": {
                                    schema_org_id: [parseJwt(sessionStorage.getItem('token'))?.schemaOrgID]
                                }
                            }
                        },
                        getMaxPage: (states, functions, response) => {
                            return Number(response?.resource?.maxPage || "");
                        },
                        apiExtraHeaders: getPermissionKey("common", "commonfunctionality", "view")
                    },
                    getListData: (data) => data?.resource?.searchResultNew || [],
                }
            }
            default: { break; }
        }
    }

    const renderPivotTable = () => {
        if (loading?.["main"]) {
            return <div className='min-h-[250px] flex items-center justify-center'>
                <GenericSpinnerLoader />
            </div>
        }

        if (error?.["main"]) {
            // return <div onClick={() => getPivotData()}>
            //     <Icons.ReloadIcon />
            //     <p>{error?.["main"] || "Something Went Wrong!"}</p>
            // </div>

            return <div className='min-h-[250px] w-full h-full flex flex-col items-center justify-center gap-2'>
                    <GenericCustomButton
                        type='retry'
                        onClick={() => getPivotData()}
                    />
                    <p className='mb-0 text-sm text-center text-fontGrey'>{error?.["main"] || "Something Went Wrong!"}</p>
                </div>
        }

        if (!filtersData?.["season"]?.["season"] || !filtersData?.["hl3name"]?.["hl3code"]) {
            // return <div className='min-h-[250px] flex items-center justify-center'>
            //     <p className='mb-0'>Please select Department and Season filter <br /> to generate the table</p>
            // </div>
            
            return <div className='min-h-[220px] mb-7 flex flex-col items-center justify-center p-[1rem]'>
                        {/* @Vishnu : Please create the no documents select icons*/}
                        <div className='mb-4'><SquareDashedMousePointer strokeWidth={1.5} size={80} /></div>
                        <LanguageTranslator tag='p' className='font-semibold mb-1'>No selection found</LanguageTranslator>
                        <LanguageTranslator tag='p' className='mb-0 text-xs text-fontGrey text-center'>Please select Department and Season filter to generate the table</LanguageTranslator>
                    </div>
        }

        const provideMapping = (key) => {
            let mapping = {
                "brand" : "Brand",
                "color" : "Color",
                "designGroupNumber" : "Design Group Number",
                "hl3Code" : "Department Code",
                "hl3Name" : "Department Name",
                "material" : "Material",
                "neck" : "Neck",
                "occasion" : "Occasion",
                "pattern" : "Pattern",
                "productId" : "Product Id",
                "season" : "Season",
                "size" : "Size",
                "sku_id" : "SKU ID",
                "status" : "Status",
                "vendorCode" : "Vendor Code",
                "vendorName" : "Vendor Name",
            };
            return mapping?.[key]
        }

        return <div className='w-full overflow-auto'>
                <PivotTableUI
                    className='my-3'
                    renderers={TableRenderers}
                    data={tableData?.map(item => {
                        let obj = {};
                        Object.keys(item || {})?.map(key => {
                            obj[provideMapping(key)] = item?.[key];
                        })

                        return obj;
                    })}
                    onChange={s => setPivotData(s)}
                    {...pivotData}
                />
                </div>
    }

    return (
        <div className='text-fontBlack'>
            <LanguageTranslator tag='p' className='text-base font-semibold mb-3'>Product Depth Analysis</LanguageTranslator>

            {/* Render the input filters */}
            <div className='mb-4 flex items-end gap-3'>
                <GenericInput
                    genInputExtraClass='!mb-0 max-w-[250px]'
                    key="hl3name"
                    type="dropdown"
                    placeholder="Select a department"
                    dependentFieldsObject = {["hl3name"]}
                    label="Department"
                    value={filtersData?.["hl3name"]?.["hl3name"]}
                    onChange={(val) => {
                        let updatedFiltersData = { ...filtersData };
                        updatedFiltersData["hl3name"] = val;
                        setFiltersData(updatedFiltersData);
                    }}
                    inputProps={() => getInputProps("hl3name")}
                />
                <GenericInput
                    genInputExtraClass='!mb-0 max-w-[250px]'
                    dependentFieldsObject = {["season"]}
                    key="season"
                    type="dropdown"
                    placeholder="Select a Season"
                    label="Season"
                    value={filtersData?.["season"]?.["season"]}
                    onChange={(val) => {
                        let updatedFiltersData = { ...filtersData };
                        updatedFiltersData["season"] = val;
                        setFiltersData(updatedFiltersData);
                    }}
                    inputProps={() => getInputProps("season")}
                />
                {/* Render the clear all button and functionality here */}
                <GenericCustomButton
                    label = "Clear All"
                    type = "default"
                    onClick={() => {
                        setFiltersData({})
                        setError({});
                        setLoading({});
                        setPivotData({});
                        setTableData([]);
                    }}
                />
            </div>

            {renderPivotTable()}

        </div>
    )
}

export default PivotTable
